// HIPAAtizer's documented AllFormsSubmitted event represents the whole workflow.
// Never forward event.data: it may contain answers and a private submission URL.
export function createHipaatizerCompletionHandler({ getFrameWindow, formOrigin, onComplete }) {
  let completed = false;
  return function handleCompletion(event) {
    const frameWindow = getFrameWindow();
    if (completed || !formOrigin || !frameWindow || event.origin !== formOrigin || event.source !== frameWindow) return false;
    const message = event.data;
    if (!message || typeof message !== 'object' || Array.isArray(message) ||
        message.kind !== 'event' || message.type !== 'AllFormsSubmitted') return false;
    // Consume once even when measurement is declined; never replay on consent changes.
    completed = true;
    onComplete?.();
    return true;
  };
}
